<div id="indicHolder">
    <div *ngIf="loading" id="loadingWhitBak">
        <div class="ldio-ns36390yc">
            <div></div>
        </div>
    </div>
    <div id="indiFilters">
        <div (click)="timeFilterSet('hoje', $event)" [ngClass]="(atual===0)?'timeFilt indiSelect':'timeFilt'">Hoje</div>
        <div (click)="timeFilterSet('sete', $event)" [ngClass]="(atual===1)?'timeFilt indiSelect':'timeFilt'">Últimos 7 dias</div>
        <div (click)="timeFilterSet('esteMes', $event)" [ngClass]="(atual===2)?'timeFilt indiSelect':'timeFilt'">Este mês</div>
        <div (click)="timeFilterSet('mesAntes', $event)" [ngClass]="(atual===3)?'timeFilt indiSelect':'timeFilt'">Mês anterior</div>
        <div id="periodo">
            <mat-form-field appearance="fill">
                <mat-label>Selecionar período</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input id="dataInicial" [(ngModel)]="dateSetup.start_date" disabled matStartDate placeholder="Data inicial">
                    <input id="dataFinal" [(ngModel)]="dateSetup.end_date" (dateChange)="changeDate($event)" disabled matEndDate placeholder="Data final">
                </mat-date-range-input>
                <mat-datepicker-toggle title="Escolher datas" matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker  disabled="false" #picker></mat-date-range-picker>
            </mat-form-field>
        </div>
        <div (click)="closeIndicatorScreen()" id="indicBtn">
            <img src="assets/img/icon-bt-chart.svg" alt=""/>
            Indicadores
        </div>
    </div>
    <!--Paginacao-->
    <!-- <div id="slidePoints">
        <div class="pointClick"></div>
        <div class="pointClick pointChoosed"></div>
        <div class="pointClick"></div>
        <div class="pointClick"></div>
    </div> -->
    <div id="slideGadges">
        <div *ngFor="let gadge of indicList" class="gadgeCont">
            <div class="gadgeTitle">
                <img src="assets/img/icon-{{gadge.type}}-lineal.svg" alt=""/>
                {{gadge.title}}
            </div>
            <div class="gadgeText">
                <div *ngIf="!gadge.graph" class="gadgeValue full">
                    <div class="numInv" *ngIf="!gadge.percent" [style.color]="'#b5cad9'"></div>
                    <span *ngIf="gadge.percent_value === 0" [style.color]="'#b5cad9'"> {{gadge.percent_value}}%</span>
                    <span *ngIf="gadge.percent_value > 0" [style.color]="'rgb(0, 201, 151)'"><img src="assets/img/arrow-green.svg" alt=""/> {{gadge.percent_value}}%</span>
                    <span *ngIf="gadge.percent_value < 0" [style.color]="'rgb(255, 115, 115)'"><img src="assets/img/arrow-red.svg" alt=""/> {{gadge.percent_value}}%</span>
                    <p *ngIf="gadge.money">{{gadge.value | currency: 'pt-br' : 'R$'}}</p>
                    <p *ngIf="!gadge.money">{{gadge.value | number:'1.0-0'}}</p>
                </div>
                <div *ngIf="gadge.graph" class="gadgeValue">
                    <div class="numInv" *ngIf="!gadge.percent" [style.color]="'#b5cad9'"></div>
                    <span *ngIf="gadge.percent_value === 0" [style.color]="'#b5cad9'"> {{gadge.percent_value}}%</span>
                    <span *ngIf="gadge.percent_value > 0" [style.color]="'rgb(0, 201, 151)'"><img src="assets/img/arrow-green.svg" alt=""/> {{gadge.percent_value}}%</span>
                    <span *ngIf="gadge.percent_value < 0" [style.color]="'rgb(255, 115, 115)'"><img src="assets/img/arrow-red.svg" alt=""/> {{gadge.percent_value}}%</span>
                    <p *ngIf="gadge.money">{{gadge.value | currency: 'pt-br' : 'R$'}}</p>
                    <p *ngIf="!gadge.money">{{gadge.value | number:'1.0-0'}}</p>
                </div>
                <!--Graphics-->
                <!--NPS-->
                <div *ngIf="gadge.type === 'evaluation'" class="gadgeGraph">
                    <div *ngIf="gadge.data.nps > 60" class="pointerBase" [style.transform]="'rotate(' + (gadge.data.nps*1.18) + 'deg)'">
                        <div class="pointerBall" [style.background]="'rgb(0 201 151)'"></div>
                    </div>
                    <div *ngIf="gadge.data.nps > 0 && gadge.data.nps <= 60" class="pointerBase" [style.transform]="'rotate(' + (gadge.data.nps*1.18) + 'deg)'">
                        <div class="pointerBall" [style.background]="'rgb(255 191 45)'"></div>
                    </div>
                    <div *ngIf="gadge.data.nps <= 0" class="pointerBase" [style.transform]="'rotate(' + (gadge.data.nps*1.18) + 'deg)'">
                        <div class="pointerBall" [style.background]="'rgb(255 115 115)'"></div>
                    </div>
                    <img class="meter" *ngIf="gadge.data.nps <= 0" src="assets/img/point-meter-chart-red-empty.svg" alt=""/>
                    <img class="meter" *ngIf="gadge.data.nps > 0 && gadge.data.nps <= 60" src="assets/img/point-meter-chart-yellow-empty.svg" alt=""/>
                    <img class="meter" *ngIf="gadge.data.nps > 60" src="assets/img/point-meter-chart-green-empty.svg" alt=""/>
                    <span>{{gadge.data.nps}}</span>
                    <h4>NPS</h4>
                </div>
                <!--Rupture-->
                <div *ngIf="gadge.type === 'missing'" class="gadgeGraph">
                    <div *ngIf="gadge.data.removed > gadge.data.changed" [style.background]="'rgba(255, 191, 45, 0.9)'" class="yellowCircle smallCircle"><span>{{gadge.data.changed}}</span></div>
                    <div *ngIf="gadge.data.removed === gadge.data.changed" [style.background]="'rgba(255, 191, 45, 0.9)'" class="yellowCircle middleCircle"><span>{{gadge.data.changed}}</span></div>
                    <div *ngIf="gadge.data.removed < gadge.data.changed" [style.background]="'rgba(255, 191, 45, 0.9)'" class="yellowCircle bigCircle"><span>{{gadge.data.changed}}</span></div>
                    <div *ngIf="gadge.data.removed > gadge.data.changed" [style.background]="'rgba(255, 115, 115, 0.9)'" class="redCircle bigCircle"><span>{{gadge.data.removed}}</span></div>
                    <div *ngIf="gadge.data.removed === gadge.data.changed" [style.background]="'rgba(255, 115, 115, 0.9)'" class="redCircle middleCircle"><span>{{gadge.data.removed}}</span></div>
                    <div *ngIf="gadge.data.removed < gadge.data.changed" [style.background]="'rgba(255, 115, 115, 0.9)'" class="redCircle smallCircle"><span>{{gadge.data.removed}}</span></div>
                </div>
                <!--Default-->
            </div>
        </div>
        <!-- <div class="gadgeCont">
            <div class="gadgeTitle">
                <img src="assets/img/icon-revenue-lineal.svg" alt=""/>
                Receita
            </div>
            <div class="gadgeText">
                <div class="gadgeValue full">
                    <span [style.color]="'rgb(0, 201, 151)'"><img src="assets/img/arrow-green.svg" alt=""/> 375%</span>
                    <span *ngIf="false" [style.color]="'rgb(255, 115, 115)'"><img src="assets/img/arrow-red.svg" alt=""/>%</span>
                    <p>R$ 5,7milhões</p>
                </div>
            </div>
        </div>
        <div class="gadgeCont">
            <div class="gadgeTitle">
                <img src="assets/img/icon-price-lineal.svg" alt=""/>
                Ticket Médio
            </div>
            <div class="gadgeText">
                <div class="gadgeValue">
                    <span [style.color]="'rgb(0, 201, 151)'"><img src="assets/img/arrow-green.svg" alt=""/> 375%</span>
                    <span *ngIf="false" [style.color]="'rgb(255, 115, 115)'"><img src="assets/img/arrow-red.svg" alt=""/>%</span>
                    <p>R$ 256,61</p>
                </div>
                <div class="gadgeGraph">

                </div>
            </div>
        </div>
        <div class="gadgeCont">
            <div class="gadgeTitle">
                <img src="assets/img/icon-smash-lineal.svg" alt=""/>
                Rupturas
            </div>
            <div class="gadgeText">
                <div class="gadgeValue">
                    <span [style.color]="'rgb(0, 201, 151)'"><img src="assets/img/arrow-green.svg" alt=""/> 375%</span>
                    <span *ngIf="false" [style.color]="'rgb(255, 115, 115)'"><img src="assets/img/arrow-red.svg" alt=""/>%</span>
                    <p>728</p>
                </div>
                <div class="gadgeGraph">

                </div>
            </div>
        </div>
        <div class="gadgeCont">
            <div class="gadgeTitle">
                <img src="assets/img/icon-point-meter.svg" alt=""/>
                Avaliações
            </div>
            <div class="gadgeText">
                <div class="gadgeValue">
                    <span [style.color]="'rgb(0, 201, 151)'"><img src="assets/img/arrow-green.svg" alt=""/> 375%</span>
                    <span *ngIf="false" [style.color]="'rgb(255, 115, 115)'"><img src="assets/img/arrow-red.svg" alt=""/>%</span>
                    <p>4.035</p>
                </div>
                <div class="gadgeGraph">
                    <img class="meter" src="assets/img/point-meter-chart-red.svg" alt=""/>
                    <img class="meter" *ngIf="false" src="assets/img/point-meter-chart-yellow.svg" alt=""/>
                    <img class="meter" *ngIf="false" src="assets/img/point-meter-chart-green.svg" alt=""/>
                    <span>-89</span>
                    <h4>NPS</h4>
                </div>
            </div>
        </div> -->
    </div>
</div>
<div (click)="closeIndicatorScreen()" id="backIndic"></div>
